import Component from '../../../shared/component';
import AvatarBuilderOption from './avatar-builder-option';
import AvatarBuilderClearOptionGroupButton from './avatar-builder-clear-option-group-button';

const OPTION_ITEM_TYPE = 'option';
const COLOR_ITEM_TYPE = 'color';

export default class AvatarBuilderOptions extends Component {
  constructor(element, opts) {
    super(...arguments);

    this.$element = $(element);

    this.avatarBuilder = opts.avatarBuilder;

    this.clearButtons = AvatarBuilderClearOptionGroupButton.initialize(
      this.$element.find(
        '.menteeAvatarBuilderModal-body-options-group-titlebar-button'
      ),
      {avatarBuilder: this.avatarBuilder}
    );
    this.options = AvatarBuilderOption.initialize(
      this.$element.find('.menteeAvatarBuilderModal-body-preview-item'),
      {avatarBuilder: this.avatarBuilder, itemType: OPTION_ITEM_TYPE}
    );
    this.colors = AvatarBuilderOption.initialize(
      this.$element.find('.menteeAvatarBuilderModal-body-color-dot'),
      {avatarBuilder: this.avatarBuilder, itemType: COLOR_ITEM_TYPE}
    );

    this.allOptions = this.options.concat(this.colors);
  }

  unbindEvents() {
    this.clearButtons.forEach((component) => {
      component.unbindEvents();
    });

    this.colors.forEach((component) => {
      component.unbindEvents();
    });

    this.options.forEach((component) => {
      component.unbindEvents();
    });
  }

  selectItem(itemId, itemType, category) {
    const item = this.findItem(itemId, itemType, category);
    const clearButton = this.findCategoryClearButton(category);

    if (item) {
      item.markAsSelected();
      if (clearButton) clearButton.markAsEnabled();
    }
  }

  unselectItem(itemId, itemType, category) {
    const item = this.findItem(itemId, itemType, category);
    const clearButton = this.findCategoryClearButton(category);

    if (item) {
      item.markAsUnselected();
      if (clearButton) clearButton.markAsDisabled();
    }
  }

  unselectAllOptions() {
    this.allOptions.forEach((option) => option.markAsUnselected());
    this.clearButtons.forEach((button) => button.markAsDisabled());
  }

  enableAllOptions() {
    this.allOptions.forEach((option) => option.markAsEnabled());
  }

  disableAllOptions() {
    this.allOptions.forEach((option) => option.markAsDisabled());
  }

  findItem(itemId, itemType, category) {
    if (itemType === OPTION_ITEM_TYPE) {
      return this.options.find(
        (option) => option.id === itemId && option.category === category
      );
    } else {
      return this.colors.find(
        (option) => option.id === itemId && option.category === category
      );
    }
  }

  findCategoryClearButton(category) {
    return this.clearButtons.find((button) => button.category === category);
  }
}
